import React from "react";
import PropTypes from "prop-types";
import * as track from '../../data/track/track';
import * as types from '../../types'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
import { connect } from "react-redux";
// @material-ui/icons
// import Weekend from "@material-ui/icons/Weekend";
import Home from "@material-ui/icons/Home";
import Business from "@material-ui/icons/Business";
import AccountBalance from "@material-ui/icons/AccountBalance";
import * as model from '../../data/model';
import * as dal from '../../data/dal';
// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import proIcon from "../../assets/img/pro.svg"
import {
    container,
    defaultFont,
    cardTitle,
    roseColor
} from "src/assets/jss/material-dashboard-pro-react.jsx";

const pricingPageStyle = theme => ({
    container: {
        ...container,
        zIndex: "4",
        [theme.breakpoints.down("sm")]: {
            paddingBottom: "100px"
        },
    },
    title: {
        ...defaultFont,

        marginTop: "5vh",
        marginBottom: "30px",
        textAlign: "center"
    },
    description: {
        fontSize: "18px",

        textAlign: "center"
    },

    cardTitleWhite: {
        ...cardTitle,
        color: " !important"
    },
    cardPricing: {
        textAlign: "center",
        "&:after": {
            backgroundColor: "rgba(0, 0, 0, 0.7) !important"
        },
        "& ul": {
            listStyle: "none",
            padding: 0,
            maxWidth: "240px",
            margin: "10px auto"
        },
        "& ul li": {
            color: "#1b1b1b",
            textAlign: "center",
            padding: "12px 0px",
            borderBottom: "1px solid rgba(153,153,153,0.3)"
        },
        "& ul li:last-child": {
            border: 0
        },
        "& ul li b": {
            color: "#3c4858"
        },
        "& h1": {
            marginTop: "30px"
        },
        "& h1 small": {
            display: "inline-flex",
            height: 0,
            fontSize: "18px"
        },
        "& h1 small:first-child": {
            position: "relative",
            top: "-17px",
            fontSize: "26px"
        },
        "& ul li svg, & ul li .fab,& ul li .fas,& ul li .far,& ul li .fal,& ul li .material-icons": {
            position: "relative",
            top: "7px"
        }
    },
    cardCategory: {
        color: "#1b1b1b",
        marginTop: "10px"
    },
    cardCategoryWhite: {
        color: "#FFFFFF",
        marginTop: "10px"
    },
    icon: {
        color: "rgba(255, 255, 255, 0.76)",
        margin: "10px auto 0",
        width: "130px",
        height: "130px",
        border: "1px solid #E5E5E5",
        borderRadius: "50%",
        lineHeight: "174px",
        "& svg": {
            width: "55px",
            height: "55px"
        },
        "& .fab,& .fas,& .far,& .fal,& .material-icons": {
            width: "55px",
            fontSize: "55px"
        }
    },

    iconWhite: {
        color: "#FFFFFF"
    },
    iconRose: {
        color: roseColor
    },
    marginTop30: {
        marginTop: "30px"
    }
});





interface PricingPageProps {
    classes: any;
    connect: types.IState
}
interface PricingPageState {

}

class PricingPage extends React.Component<PricingPageProps, PricingPageState> {
    changePlan(plan:model.PlanCode)
    {
        switch(plan)
        {
            case(model.PlanCode.premium):
                track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.changePlanPremium);
                break;
                case(model.PlanCode.free):
                track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.changePlanFree);
                break
                case(model.PlanCode.pro):
                track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.changePlanPro);
                break
        }
        alert("Thanks for wanting to upgrade.  We are still setting up billing.  So enjoy Premium features until its finished.")
    }
    render() {
        let me  =this;
        const { classes } = this.props;
        let plan = dal.GetPlans().find(x => x.plan_code == this.props.connect.lo_CustomerBalance.val().plan_code);
        if (!plan) {
            this.props.connect.lo_ctx.val().CustomerBalance.changePlan(model.PlanCode.trail);
            return (<div></div>)
        }
        return (
            <div className={classes.container}>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={6}>
                        <h2 className={classes.title}>Pick the best plan for you</h2>
                        <h5 className={classes.description}>
                            Get higher quality voices and more podcast.
            </h5>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">





                    <GridItem xs={12} sm={12} md={3}>
                        <Card pricing raised>
                            <CardBody pricing>
                                <h3 className={classes.cardCategory}>Free</h3>

                                <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
                                    $0
                </h3>
                                <p className={classes.cardDescription}>
                                    Kicking the tires
                </p>
                                <ul>
                                    <li style={{ color: 'black' }}>3 Podcasts</li>
                                    <li style={{ color: 'black' }}>Normal Voices / Some Ads</li>
                                    <li style={{ color: 'black' }}>Limited Streaming</li>

                                </ul>
                                {(plan.plan_code == model.PlanCode.trail || plan.plan_code == model.PlanCode.free) &&
                                    <b color='green'>Your Current Plan</b>
                                }
                                {(plan.plan_code != model.PlanCode.trail && plan.plan_code != model.PlanCode.free) &&
                                    <Button  onClick={(e)=>{me.changePlan( model.PlanCode.premium)}} round color="rose">
                                        Choose plan
                </Button>
                                }
                            </CardBody>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                        <Card pricing raised>
                            <CardBody pricing>
                                <h3 className={classes.cardCategory}>Pro</h3>

                                <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
                                    $5
                </h3>
                                <p className={classes.cardDescription}>
                                    More podcast! More Fun!
                </p>
                                <ul className="color:black">
                                    <li style={{ color: 'black' }}>10 Podcasts</li>
                                    <li style={{ color: 'black' }}>Premium Voices / Ad FREE</li>
                                    <li style={{ color: 'black' }}>Priority Streaming</li>

                                </ul>
                                {(plan.plan_code == model.PlanCode.pro ) &&
                                    <b color='green'>Your Current Plan</b>
                                }
                                {(plan.plan_code != model.PlanCode.pro) &&
                                    <Button  onClick={(e)=>{me.changePlan( model.PlanCode.premium)}} round color="rose">
                                        Choose plan
                </Button>
                                }
                            </CardBody>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                        <Card pricing raised>
                            <CardBody pricing>
                                <h3 className={classes.cardCategory}>Premium</h3>

                                <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
                                    $16
                </h3>
                                <p className={classes.cardDescription}>
                                    Customize Voices!  Best Quality!
                </p>
                                <ul>
                                    <li style={{ color: 'black' }}>Unlimited Podcasts</li>
                                    <li style={{ color: 'black' }}>Premium Voices / Ad FREE</li>
                                    <li style={{ color: 'black' }}>Priority Streaming</li>
                                </ul>
                                {(plan.plan_code == model.PlanCode.premium ) &&
                                    <b color='green'>Your Current Plan</b>
                                }
                                {(plan.plan_code != model.PlanCode.premium) &&
                                    <Button onClick={(e)=>{me.changePlan( model.PlanCode.premium)}}  round color="rose">
                                        Choose plan
                </Button>
                                }
                            </CardBody>
                        </Card>
                    </GridItem>

                </GridContainer>
            </div>
        );
    }
}


export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(pricingPageStyle as any)(PricingPage));



// WEBPACK FOOTER //
// ./src/views/credits/Plan.tsx